import * as types from './types';

const INITIAL_STATE = {
  data: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PROHIBITED_ITEMS_REPORT_CLEAR_REPORT:
      return { ...INITIAL_STATE };

    case types.PROHIBITED_ITEMS_REPORT_REPORT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.PROHIBITED_ITEMS_REPORT_GENERATE_REPORT:
      return {
        ...state,
        data: action.payload,
      };

    case types.PROHIBITED_ITEMS_REPORT_REPORT_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/report/reducer.js